/* eslint-disable */
<template>
  <div
    v-if="companySelectModalState"
    v-on-clickaway="away"
    class="menu-cont"
  >
    <input
      id="clientinput"
      v-model="searchTerm"
      type="text"
      class="search-term"
      placeholder="Search clients"
    >
    <ul class="client-menu-list">
      <li
        v-for="(client, index) in clientsToShow"
        :key="index"
        tabindex="0"
        class="client"
        :class="{ clientSelected: client.username === currentClient }"
        @click="changeClient(client)"
        @keypress="changeClient(client)"
      >
        <span v-if="searchTerm === ''">{{ client.display_name }}</span>
        <span
          v-else
          class="searchClient"
        >
          {{ displayPreSearchString(client.display_name) }}<span class="searchTerm">
            {{ displaySearchString(client.display_name) }}</span>
          {{ displayPostSearchString(client.display_name) }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway';

export default {
  name: 'RareCompanyMenu',
  directives: {
    onClickaway,
  },
  data() {
    return {
      searchTerm: '',
    };
  },
  computed: {
    companySelectModalState() {
      return this.$store.getters.companySelectModalState;
    },
    currentClient() {
      return this.$store.getters.currentClient;
    },
    currentClientDisplayName() {
      return this.$store.getters.currentClientDisplayName;
    },
    clientList() {
      return this.$store.getters.clientList;
    },
    clientsToShow() {
      return this.clientList.filter((client) => this.containsSearchTerm(client.display_name));
    },
  },
  created() {
    document.addEventListener('keyup', this.watchForEsc);
  },
  updated() {
    if (this.companySelectModalState) {
      document.getElementById('clientinput').focus();
    }
  },
  methods: {
    containsSearchTerm(clientName) {
      const clientForComparison = clientName.toLowerCase();
      const searchTermForComparison = this.searchTerm.toLowerCase();
      return this.searchTerm === ''
        ? true
        : clientForComparison.includes(searchTermForComparison);
    },
    displayPreSearchString(client) {
      return client.substr(0, client.toLowerCase().indexOf(this.searchTerm.toLowerCase()));
    },
    displaySearchString(client) {
      return client.substr(
        client.toLowerCase().indexOf(this.searchTerm.toLowerCase()),
        this.searchTerm.length,
      );
    },
    displayPostSearchString(client) {
      return client.substr(client.toLowerCase().indexOf(this.searchTerm.toLowerCase())
        + this.searchTerm.length);
    },
    changeClient(newClient) {
      this.$store.commit('updateCurrentClient', newClient.username);
      this.$store.commit('updateCurrentClientDisplayName', newClient.display_name);
      this.$store.commit('updateCurrentParamsHash');
      this.$store.commit('updateCompanySelectModalState', false);
      this.$root.$emit('updateClient', newClient);
    },
    watchForEsc(key) {
      if (key.keyCode === 27) {
        this.$store.commit('updateCompanySelectModalState', false);
      }
    },
    away() {
      this.$store.commit('updateCompanySelectModalState', false);
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";
  .menu-cont {
    position: absolute;
    top: 60px;
    left: 0;
    width: 297px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    box-shadow: 0 20px 30px 0 rgba(0, 0, 0, 0.4);
    background-color: #ffffff;
    z-index: 9999;
  }
  .search-term {
    width:100%;
    height: 72px;
    background: url("../../assets/img/search.png") no-repeat 11px;
    border-bottom: solid 1px #b4bfc8;
    padding-left: 43px;
    background-size: 17px 17px;
  }

  .client-menu-list {
    list-style: none;
    margin: 30px 10px 30px 10px;
  }

  .client {
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: 1px;
    color: #4a5b68;
    padding: 8px;
    cursor: pointer;
  }

  .searchClient {
    font-weight: lighter;
  }

  .searchTerm {
    font-weight: bold;
  }

  .client:hover, .clientSelected {
    color: #ffffff;
    background-color: $green-highlight;
  }

</style>
